import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Section from '../Section/Section';
const CategoryPost = t0 => {
  const $ = _c(8);
  const {
    blogUrl,
    category
  } = t0;
  const history = useHistory();
  let t1;
  if ($[0] !== blogUrl || $[1] !== history) {
    t1 = postSlug => {
      history.push(`/${blogUrl}${postSlug}`);
    };
    $[0] = blogUrl;
    $[1] = history;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleReadAllClick = t1;
  if (!category) {
    return null;
  }
  let t2;
  if ($[3] !== handleReadAllClick) {
    t2 = postSlug_0 => handleReadAllClick(postSlug_0);
    $[3] = handleReadAllClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== category || $[6] !== t2) {
    t3 = <Section category={category} posts={category.postsConfig} onReadAllClick={t2} key={category.slug} />;
    $[5] = category;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
CategoryPost.propTypes = {
  blogUrl: PropTypes.string,
  category: PropTypes.shape({
    slug: PropTypes.string,
    text: PropTypes.string,
    postsConfig: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      metaDescription: PropTypes.string
    }))
  })
};
export default React.memo(CategoryPost);